import { render, staticRenderFns } from "./Quadro_II_A.vue?vue&type=template&id=54c71e73"
import script from "./Quadro_II_A.vue?vue&type=script&lang=js"
export * from "./Quadro_II_A.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports